<div class="d-flex flex-column m-4">
	<div class="d-flex flex-column">
		<img src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Focus-With-Cloud-New-Trans.png" class="logo" />
	</div>
</div>
